import { DialogHeader } from "@imi/ui/components/Dialog/DialogHeader.js";
import { Heading } from "@imi/ui/components/Heading/Heading.js";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { DialogErrorFallback as DefaultErrorFallback } from "../../../components/DialogErrorFallback";

export function DialogErrorFallback(props: FallbackProps) {
  const { t } = useTranslation("settings", {
    keyPrefix: "technicalPreferences.waterCharacteristics",
  });

  return (
    <>
      <DialogHeader>
        <Heading as="h3" subTitle={t("subTitle")}>
          {t("title")}
        </Heading>
      </DialogHeader>
      <DefaultErrorFallback {...props} />
    </>
  );
}
